const CHANGELOG_TYPES = {
  TRANSPORT: 'TRANSPORT',
  INSTANCE: 'INSTANCE',
  WAREHOUSE_ORDER: 'WAREHOUSE_ORDER',
};

export default CHANGELOG_TYPES;
